export default "__VITE_ASSET__FhjMc_E6__"